// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v8Six","select":"styles_select__2iz9P"};